"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkNode = exports.parse = void 0;
const mathjs_1 = require("mathjs");
const mathScope_1 = require("./mathScope");
// mathjs functions and constants a formula may use, by name or operator; create() ignores the keys
const FUNCTIONS = {
    add: mathjs_1.addDependencies,
    subtract: mathjs_1.subtractDependencies,
    multiply: mathjs_1.multiplyDependencies,
    divide: mathjs_1.divideDependencies,
    mod: mathjs_1.modDependencies,
    pow: mathjs_1.powDependencies,
    unaryMinus: mathjs_1.unaryMinusDependencies,
    unaryPlus: mathjs_1.unaryPlusDependencies,
    equal: mathjs_1.equalDependencies,
    unequal: mathjs_1.unequalDependencies,
    smaller: mathjs_1.smallerDependencies,
    smallerEq: mathjs_1.smallerEqDependencies,
    larger: mathjs_1.largerDependencies,
    largerEq: mathjs_1.largerEqDependencies,
    and: mathjs_1.andDependencies,
    or: mathjs_1.orDependencies,
    not: mathjs_1.notDependencies,
    xor: mathjs_1.xorDependencies,
    abs: mathjs_1.absDependencies,
    ceil: mathjs_1.ceilDependencies,
    floor: mathjs_1.floorDependencies,
    round: mathjs_1.roundDependencies,
    fix: mathjs_1.fixDependencies,
    sign: mathjs_1.signDependencies,
    sqrt: mathjs_1.sqrtDependencies,
    cbrt: mathjs_1.cbrtDependencies,
    exp: mathjs_1.expDependencies,
    log: mathjs_1.logDependencies,
    log10: mathjs_1.log10Dependencies,
    log2: mathjs_1.log2Dependencies,
    min: mathjs_1.minDependencies,
    max: mathjs_1.maxDependencies,
    sum: mathjs_1.sumDependencies,
    mean: mathjs_1.meanDependencies,
    median: mathjs_1.medianDependencies,
    number: mathjs_1.numberDependencies,
    isNaN: mathjs_1.isNaNDependencies,
    pi: mathjs_1.piDependencies,
    e: mathjs_1.eDependencies,
    PI: mathjs_1.PIDependencies,
    E: mathjs_1.EDependencies,
};
// parse stays out of FUNCTIONS so its name isn't allowed; checkNode, not this instance, limits what a formula names
({ parse: exports.parse } = (0, mathjs_1.create)({ ...FUNCTIONS, parseDependencies: mathjs_1.parseDependencies }));
const ALLOWED_FUNCTIONS = new Set(Object.keys(FUNCTIONS));
const ALLOWED_NAMES = new Set([...Object.keys(mathScope_1.mathScope), ...ALLOWED_FUNCTIONS]);
// Scalar maths only: no ranges, matrices, units or access to the mathjs instance
const ALLOWED_NODES = new Set([
    'ConstantNode',
    'SymbolNode',
    'OperatorNode',
    'ParenthesisNode',
    'FunctionNode',
    'ConditionalNode',
    'RelationalNode',
]);
/** Throws the reason `node` can't be used; `variables` maps each generated symbol to its placeholder token */
const checkNode = (node, variables) => {
    node.traverse((child) => {
        if (!ALLOWED_NODES.has(child.type)) {
            throw new Error(`${child.type} is not allowed in a formula`);
        }
        if ((0, mathjs_1.isOperatorNode)(child)) {
            if (!ALLOWED_FUNCTIONS.has(child.fn)) {
                throw new Error(`Operator ${child.op} is not allowed`);
            }
            // Text substitution joined values into numbers (`2{a}` was 25 for 5), and mathjs gives implicit
            // multiplication special precedence after a number (10/2(1+4) is 25), so require *
            if (child.implicit) {
                throw new Error('Use * to multiply');
            }
        }
        // `{a} (2)` parses as a call to the variable
        if ((0, mathjs_1.isFunctionNode)(child) && (0, mathjs_1.isSymbolNode)(child.fn) && variables.has(child.fn.name)) {
            throw new Error(`Variable {${variables.get(child.fn.name)}} needs an operator next to it`);
        }
        if ((0, mathjs_1.isSymbolNode)(child) && !variables.has(child.name) && !ALLOWED_NAMES.has(child.name)) {
            throw new Error(`Unknown name "${child.name}"`);
        }
    });
};
exports.checkNode = checkNode;
